import { DataEntry, MetadataCard } from '@common/components/MetadataCard';
import { Box } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { useSelectedClip } from '../hooks/useSelectedClipSelectors';
import { Clip } from '../types';

const BLACK_LIST: (keyof Clip)[] = [
    'mediaObjectId',
    'mediaObjectType',
    'mediaIdentifiers',
    'collectionId',
    'audioTracks',
    'aspectRatio',
    'frameRate',
    'duration',
    'durationSeconds',
];

export const InfoSection = () => {
    const { t } = useTranslation('clipDetails');
    const { selectedClip, isLoading } = useSelectedClip();

    const metadataObject = Object.entries(selectedClip).filter(
        ([key]) => !BLACK_LIST.includes(key as keyof Clip),
    );
    const translatedMetadataObject = metadataObject.reduce(
        (acc, [key, value]) => {
            acc.push({ label: t(`metadata.${key}`), value });
            return acc;
        },
        [] as DataEntry[],
    );

    return (
        <Box>
            <MetadataCard
                title={t('technicalInformation')}
                data={translatedMetadataObject}
                columns={2}
                rows={4}
                isLoading={isLoading}
            />
        </Box>
    );
};
